export default __webpack_public_path__ + "static/media/IMG_8046.becc1fe7.png";